import { render, staticRenderFns } from "./about-me.vue?vue&type=template&id=15c53ce6"
import script from "./about-me.vue?vue&type=script&lang=js"
export * from "./about-me.vue?vue&type=script&lang=js"
import style0 from "./about-me.vue?vue&type=style&index=0&id=15c53ce6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports